import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kznjgqp8wa: FaireBrandEntity = {
  token: "b_kznjgqp8wa",
  type: "brand",
  name: "Calder Crystals",
  avatarUrl:
    "https://cdn.faire.com/fastly/083509126466ce5a3f416f8fd23c4df2d7764991761130a4cec78e5a6a78a29c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8e172f9c53747aea1309d5142fb96323a3696c0bc898fc8e5657800323510811.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/083509126466ce5a3f416f8fd23c4df2d7764991761130a4cec78e5a6a78a29c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8e172f9c53747aea1309d5142fb96323a3696c0bc898fc8e5657800323510811.jpeg",
  location: "GBR",
  minimumOrderDollars: 182,
  rating: 5,
  reviewCount: 9,
  isInsider: false,
  description:
    "Calder Crystals: The Source for Exceptional Minerals and Advanced Healing Crystals\n\nAt Calder Crystals, we believe that true crystal mastery and retail distinction lie in the exceptional. We aren't just a supplier; we are curators dedicated to sourcing the world's most rare, sought-after, and energetically significant mineral pieces for your discerning shop.\n\nOur mission is to distinguish your inventory beyond the common finds. For retailers looking to offer unparalleled depth and quality, Calder Crystals is your wholesale partner. We specialize in specimens that capture the imagination of the most knowledgeable collectors, ensuring your shelves hold true geological treasures.\n\nFurthermore, we focus intently on advanced metaphysical tools. We are proud to wholesale high-vibration healing crystals such as Phenacite, Petalite, Azeztulite, and other specialized formations—pieces recognized by advanced practitioners for their potent energy and transformational qualities. By stocking these advanced crystals, you establish your business as a serious destination for metaphysical study and healing work.\n\nPartner with Calder Crystals on Faire to unlock inventory that offers superior quality, scarcity, and undeniable energetic impact. We provide the exceptional mineral resources you need to stand out, attract specialized clientele, and deepen the unique power of your brand.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.410Z",
    importedBy: "entity-db-cli",
  },
};
